import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { faqData } from '../data/mockData';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">FAQ</h2>
          <p className="text-gray-400 text-lg">
            Our Telegram community and staff are here to help!
          </p>
          <Button
            className="mt-6 bg-sky-600 hover:bg-sky-700 text-white"
            size="lg"
            data-testid="faq-join-telegram-btn"
            onClick={() => window.open('https://t.me/tokenos_ai', '_blank')}
          >
            <MessageCircle className="mr-2" size={20} />
            Join Telegram
          </Button>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl border border-white/10 px-6"
            >
              <AccordionTrigger className="text-white hover:text-purple-400 text-lg font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;